import { useFormikContext } from 'formik'
import { useState } from 'react'
import { MdAdd } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IVersionEngineFormValues } from '~/types/arbitration'

import AddVersionsModal from '../AddVersions'

import Button from '~/components/Buttons/Button'
import Label from '~/components/Label'
import Tag from '~/components/Tag'
import { ENGINE_TYPE } from '~/types/arbitration'

import './styles.scss'

interface Props {
  appKey: string
  deviceType: string
  engineType: ENGINE_TYPE.VERSION | ENGINE_TYPE.ARCHIVE
}

const EditVersions = ({ appKey, deviceType, engineType }: Props): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    setFieldValue,
    values: { eligibilityError, versions },
  } = useFormikContext<IVersionEngineFormValues>()

  const hasEligibilityError = (version: string) => eligibilityError && Object.keys(eligibilityError).includes(version)

  const handleRemoveVersion = (versionToRemove: string) => {
    const newVersions = versions.filter((version) => version !== versionToRemove)
    setFieldValue('versions', newVersions)
  }

  const handleAddVersion = ({
    appVersions,
    eligibilityError,
    force,
  }: {
    appVersions: string[]
    eligibilityError?: Record<string, string>
    force: boolean
  }) => {
    setFieldValue('versions', [...versions, ...appVersions])
    setFieldValue('force', force)
    setFieldValue('eligibilityError', eligibilityError)
    setIsModalOpen(false)
  }

  const toggleModal = (isOpen: boolean) => () => setIsModalOpen(isOpen)

  return (
    <div className="edit-versions-component">
      <div className="edit-versions-component__title">
        <Label label="Versions" />
        <Button onClick={toggleModal(true)} size="small" type="button">
          <MdAdd color="#fff" size={16} /> Add version
        </Button>
      </div>
      <div className="edit-versions-component__list">
        {versions.map((version, index) => (
          <Tag
            key={`tag-${index}`}
            onRemove={() => handleRemoveVersion(version)}
            tooltip={hasEligibilityError(version) ? 'This version will be removed from its group on save' : undefined}
            value={version}
            variant={engineType === ENGINE_TYPE.ARCHIVE ? 'primary' : 'secondary'}
          />
        ))}
      </div>
      <AddVersionsModal
        appKey={appKey}
        deviceType={deviceType}
        engineType={engineType}
        isOpen={isModalOpen}
        onClose={toggleModal(false)}
        onSave={handleAddVersion}
        title="Add versions"
      />
    </div>
  )
}

export default EditVersions
